import React from "react";
import { BrowserRouter, Routes, Route} from 'react-router-dom';
import Home from './views/Home';
import Partnership from './views/Partnership';
import Pricing from './views/Pricing';
import Product from "./views/Product";
import Contact from "./views/Contact";
import Support from "./views/Support";
import { Signup } from "./views/Signup";
import { AccountValidation } from "./views/AccountValidation";
import { Password } from "./views/Password";
import TermsOfUse from "./views/TermsOfUse";
import Subscription from "./views/Subscription";
import { Error } from "./views/Error";

function App() {
  return (

    <BrowserRouter>
        <Routes>
    
          <Route path="/" element={ <Home /> }> </Route>

          <Route path="/tarifs" element={ <Pricing /> }> </Route>

          <Route path="/partenariats" element={ <Partnership /> }> </Route>

          <Route path="/support" element={ <Support /> }> </Route>

          <Route path="/produits" element={ <Product /> }> </Route>

          <Route path="/contact" element={ <Contact /> }> </Route>

          <Route path="/inscription" element={ <Signup /> }> </Route>

          <Route path="/validation-compte" element={ <AccountValidation /> }> </Route>

          <Route path="/mot-de-passse" element={ <Password /> }> </Route>

          <Route path="/condition-utilisation" element={ <TermsOfUse /> }> </Route>

          <Route path="/subscription/:id" element={ <Subscription /> }> </Route>
    
          <Route path="*" element={ <Error />  } ></Route> 
    
    
      
    
        </Routes>
      </BrowserRouter>
     
  );
}

export default App;
